import React, { useContext, useEffect } from "react";
import * as styles from "../styles/module/external_link_modal.module.scss";
import { ModalContext } from "./Layout";

const ExternalLinkModal = () => {
  const contextValue = useContext(ModalContext);
  if (contextValue === null) {
    throw new Error('Providerが設定されていません。')
  }
  
  // スクロール制御
  useEffect(() => {
    const body = document.body;
    const html = document.querySelector('html');
    if (contextValue.isOpen) {
      body.style.overflow = 'hidden';
      html.style.scrollbarGutter = 'stable';
    } else {
      body.style.overflow = '';
      html.style.scrollbarGutter = '';
    }
  }, [contextValue.isOpen]);

  if (!contextValue.isOpen) return null;

  // 外部サイトへ遷移する
  const redirectExternalSite = (url) => {
    window.open(url, '_blank');
    contextValue.closeModal();
  }

  return <>
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <p>NRI Netcom Blogへリンクします。</p>
        <div className={styles.buttonWrap}>
          <button type="button" className="btn--secondary btn--small btn--compact" onClick={contextValue.closeModal}>キャンセル</button>
          <button type="button" className="btn--primary btn--small btn--compact" onClick={() => {redirectExternalSite(contextValue.externalSiteUrl)}}>OK</button>
        </div>
      </div>
    </div>
  </>;
};

export default ExternalLinkModal;